export default __webpack_public_path__ + "static/media/03_Read-a-book_Share.49f2763c.jpg";